import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "RoomPreferenceOption", webpackPrefetch: false */ './lazyIndex')
);

export const lazyInitRoomPreferencesSetting = new LazyAction(
    lazyModule,
    m => m.initRoomPreferencesSetting
);
